<div [dir]="this.app.getUserDire()">
    <div class="d-flex justify-content-between p-2">
        <div></div>
        <p class="interP m-0">{{ 'social.editPost' | translate }}</p>
        <mat-icon (click)="cancel()" class="xIcon material-symbols-outlined pointer">cancel</mat-icon>
    </div>
    
    <hr class="mb-0">
    
    <div class="p-3" [formGroup]="form">
    
        <div class="d-flex mb-2">
    
            <img class="border-less" [src]="app.getUserImage(app?.getUserData()?.picture)" alt="User Image">
    
            <div class="mx-2 d-flex align-items-start">
                <div>
                    <p class="my-1 posterName">{{app?.getUserData()?.fullName}}</p>
                    <p class="m-0 posterSpech">{{app?.getUserData()?.speciality}}</p>
                </div>
            </div>
        </div>
    
        <mat-form-field class="w-100" appearance="outline">
            <mat-label> {{ 'social.whatsYourMind' | translate }} </mat-label>
            <textarea formControlName="PostText" class="h-160" autocomplete="off" type="text" matInput cdkTextareaAutosize
                #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" cdkAutosizeMaxRows="9"></textarea>
        </mat-form-field>
    
    
        <div class="mt-4 d-flex justify-content-center">
            <button (click)="cancel()" class="btn cancelBtn w-30 mx-1">{{ 'social.dismiss' | translate }}</button>
            <button [disabled]="this.form.controls.PostText.value == initPostText" (click)="submit()" class="btn bgMain w-30 mx-1">{{ 'social.edit' | translate }}</button>
        </div>
    
    </div>
</div>